// // import React from "react";
// // import ReactECharts from "echarts-for-react";
// // import * as echarts from "echarts";

// // interface DoughnutChartProps {
// //   data: any;
// // }

// // const DoughnutChart: React.FC<DoughnutChartProps> = ({ data }) => {
// //   const option: echarts.EChartsOption = {
// //     title: {
// //       text: "New vs Returning Users",
// //       left: "right",
// //       top: 10,
// //       textStyle: {
// //         fontSize: 16,
// //         fontWeight: "bold",
// //       },
// //     },
// //     tooltip: {
// //       trigger: "item",
// //     },
// //     legend: {
// //       orient: "vertical",
// //       right: "10%",
// //       top: "center",
// //       icon: "circle",
// //       textStyle: {
// //         fontSize: 12,
// //       },
// //     },
// //     series: [
// //       {
// //         name: "New vs Returning Users",
// //         type: "pie",
// //         radius: ["65%", "85%"], // Doughnut shape
// //         center: ["40%", "50%"],
// //         data: [
// //           {
// //             value: 83.7,
// //             name: "Returning Users",
// //             itemStyle: { color: "#4589FF" },
// //           }, // Blue
// //           { value: 16.3, name: "New Users", itemStyle: { color: "#E0E0E0" } }, // Gray
// //         ],
// //         label: {
// //           show: true,
// //           position: "outside",
// //           formatter: "{d}%", // Show percentage
// //           fontSize: 14,
// //           fontWeight: "bold",
// //         },
// //         labelLine: {
// //           show: true,
// //           length: 15,
// //           length2: 10,
// //         },
// //       },
// //     ],
// //   };

// //   return (
// //     <div className="flex flex-col items-center w-full p-4 bg-white rounded-lg border relative hover:outline hover:outline-2 hover:outline-[#3F81FE]">
// //       <ReactECharts
// //         option={option}
// //         style={{ width: "100%", height: "300px" }}
// //       />
// //       {/* <div className="w-fit24 absolute top-[50%] left-[50%] translate-x-[-113%] translate-y-[-50%]">New vs Returning Users</div> */}
// //     </div>
// //   );
// // };

// // export default DoughnutChart;

// import React, { Suspense } from "react";
// import * as echarts from "echarts";
// import { getNewAndReturningUsers } from "../../../common/Constants";

// const ReactECharts = React.lazy(() => import("echarts-for-react"));

// interface DoughnutChartProps {
//   data: any;
//   isLoading?: boolean;
// }

// const DoughnutChart: React.FC<DoughnutChartProps> = ({ data, isLoading }) => {
//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center w-full h-[300px] p-4 bg-white rounded-lg border animate-pulse">
//         <div className="w-32 h-32 rounded-full bg-gray-300" />
//       </div>
//     );
//   }
//   const sessions = data?.Sessions ?? [];

//   const { newUsers, returningUsers } = getNewAndReturningUsers(sessions);

//   const option: echarts.EChartsOption = {
//     title: {
//       text: "New vs Returning Users",
//       left: "right",
//       top: 10,
//       textStyle: {
//         fontSize: 16,
//         fontWeight: "bold",
//       },
//     },
//     tooltip: {
//       trigger: "item",
//     },
//     legend: {
//       orient: "vertical",
//       right: "10%",
//       top: "center",
//       icon: "circle",
//       textStyle: {
//         fontSize: 12,
//       },
//     },
//     series: [
//       {
//         name: "New vs Returning Users",
//         type: "pie",
//         radius: ["65%", "85%"],
//         center: ["40%", "50%"],
//         data: [
//           {
//             value: returningUsers?.length,
//             name: "Returning Users",
//             itemStyle: { color: "#4589FF" },
//           },
//           {
//             value: newUsers?.length,
//             name: "New Users",
//             itemStyle: { color: "#E0E0E0" },
//           },
//         ],
//         label: {
//           show: true,
//           position: "outside",
//           formatter: "{d}%",
//           fontSize: 14,
//           fontWeight: "bold",
//         },
//         labelLine: {
//           show: true,
//           length: 15,
//           length2: 10,
//         },
//       },
//     ],
//   };

//   return (
//     <div className="flex flex-col items-center w-full p-4 bg-white rounded-lg border relative hover:outline hover:outline-2 hover:outline-[#3F81FE]">
//       <Suspense fallback={<div>Loading chart...</div>}>
//         <ReactECharts
//           option={option}
//           style={{ width: "100%", height: "300px" }}
//         />
//       </Suspense>
//     </div>
//   );
// };

// export default DoughnutChart;

import React, { Suspense } from "react";
import * as echarts from "echarts";
import { getNewAndReturningUsers } from "../../../common/Constants";

const ReactECharts = React.lazy(() => import("echarts-for-react"));

interface DoughnutChartProps {
  data: any;
  isLoading?: boolean;
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({ data, isLoading }) => {
  const sessions = data?.Sessions ?? [];

  const { newUsers, returningUsers } = getNewAndReturningUsers(sessions);

  const option: echarts.EChartsOption = {
    title: {
      text: "New vs Returning Users",
      left: "right",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      right: "10%",
      top: "center",
      icon: "circle",
      textStyle: {
        fontSize: 12,
      },
    },
    series: [
      {
        name: "New vs Returning Users",
        type: "pie",
        radius: ["65%", "85%"],
        center: ["40%", "50%"],
        data: [
          {
            value: returningUsers.length,
            name: "Returning Users",
            itemStyle: { color: "#4589FF" },
          },
          {
            value: newUsers.length,
            name: "New Users",
            itemStyle: { color: "#E0E0E0" },
          },
        ],
        label: {
          show: true,
          position: "outside",
          formatter: "{d}%",
          fontSize: 14,
          fontWeight: "bold",
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
        },
      },
    ],
  };
  return (
    <div className="flex flex-col items-center w-full p-4 bg-white rounded-lg border relative">
      {isLoading ? (
        <div className="flex flex-row items-center justify-between w-full h-[300px] p-4 bg-white  relative">
          {/* Left: Chart Skeleton */}
          <div className="relative w-1/2 flex justify-center items-center">
            <div className="w-32 h-32 bg-gray-200 rounded-full" />
            <div className="absolute w-20 h-20 bg-white rounded-full" />
          </div>

          {/* Right: Legend Skeleton */}
          <div className="w-1/2 flex flex-col justify-center gap-4 px-6">
            {/* Title Skeleton */}
            <div className="w-32 h-4 bg-gray-200 rounded" />

            {/* Legend Items */}
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 rounded-full bg-blue-200" />
              <div className="w-24 h-3 bg-gray-200 rounded" />
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 rounded-full bg-gray-300" />
              <div className="w-20 h-3 bg-gray-200 rounded" />
            </div>
          </div>
        </div>
      ) : (
        <Suspense
          fallback={<div className="text-center">Loading chart...</div>}
        >
          <ReactECharts
            option={option}
            style={{ width: "100%", height: "300px" }}
          />
        </Suspense>
      )}
    </div>
  );
};

export default DoughnutChart;
